/**
 * Zweck: Beschreibt class AppLayoutsFullheightComponent und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/layouts/app.layouts.fullheight.component.ts.
 */
export class AppLayoutsFullheightComponent {
/**
 * Beschreibt Methode isFullHeight und ihren Rückgabevertrag.
 */
  isFullHeight() {
    return true;
  }
}
